import { swalFire } from '@/functions/swalHelper'

/**
 * Displays an error alert using swalHelper.
 * @param {Object} data - The error data object.
 * @param {null} [customTitle=null] - Optional custom title for the alert.
 * @param {null} [customMessage=null] - Optional custom message for the alert.
 * @param {string} [errorPath='ERR3334'] - Optional error path for additional error info.
 */
async function showErrorAlert (data, customTitle = null, customMessage = null, errorPath = 'ERR3334') {
  const swalTitle = customTitle || 'Tidak Berhasil<br>Memuat Konten'
  const errorCode = `Kode Error: ${errorPath || data?.status}`
  const errorMessage = `${customMessage || data?.message}`

  await swalFire({
    imageUrl: 'https://cdn.karier.mu/kariermu/assets/illustrations/server-busy.webp',
    imageWidth: 192,
    title: `${swalTitle}`,
    html: `
      <p class="font-paragraph-5 text-ui-primary text-center m-0">
        Terjadi gangguan di halaman ini.<br>
        coba beberapa saat lagi.<br>
        ${errorCode}<br>
      </p>
      <p class="font-paragraph-7 s-mt-3">${errorMessage ?? ''}</p>
    `,
    confirmButtonText: 'Mengerti'
    // ! TODO: Add dynamic options confirm/cancel button here if needed on the future
  })
}

export { showErrorAlert }
